// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header__1Qvfj","logo":"styles__logo__h1ePP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/styles.scss
// module id = 890
// module chunks = 0